import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { MailExpiryReminder as MailExpiryBannerType } from './MailExpiryReminder.tsx';

const LazyMailExpiryBanner = lazyAfterPaint<typeof MailExpiryBannerType>(
	() =>
		import(/* webpackChunkName: "async-mail-expiry-banner" */ './MailExpiryReminder.tsx').then(
			({ MailExpiryReminder }) => MailExpiryReminder,
		),
	{
		ssr: true,
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
	},
);

export const MailExpiryBannerAsync = (): React.JSX.Element => (
	<JSErrorBoundary
		id="async-mail-expiry-banner"
		packageName="jiraPlatformUiMailExpiryReminder"
		fallback="flag"
	>
		<Placeholder name="async-mail-expiry-banner" fallback={null}>
			<LazyMailExpiryBanner />
		</Placeholder>
	</JSErrorBoundary>
);
